<script>
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import FormError from "@/components/molecules/form/form-error";

export default {
  name: "DeleteCardForm",
  components: {
    LazyImage,
    Button,
    Titre,
    Badge,
    Icon,
    FormError
  },
  props: {
    carte: {
      type: Object,
      required: false,
      default: () => {}
    },
    error: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ["deleteCarte"]
};
</script>

<template>
  <div class="u-flex u-flex-column u-flex-align-center@md">
    <div class="u-flex u-flex-column u-flex-align-center">
      <Badge
        size="lg"
        circle
        variant="primary"
        class="u-flex-shrink-none u-mb-xs"
      >
        <Icon
          name="alert"
          variant="white"
          size="sm"
        />
      </Badge>
      <Titre
        tag="h1"
        variant="primary"
        size="md"
        class="u-text-center u-mb-md"
      >
        Etes-vous sûr de vouloir supprimer <br class="u-none@xs">votre carte bancaire ?
      </Titre>
    </div>

    <div class="c-payment-card-list-delete__content">
      <p class="u-flex u-mb-xs">
        {{ carte.attributes.libelle }}
      </p>
      <div class="u-flex u-flex-align-center">
        <LazyImage
          :src="carte.attributes.reseau_emeteur_logo"
          class="u-mr-sm"
          alt="cb"
          width="45"
          height="28"
        />
        <p>
          {{ carte.attributes.reseau_emeteur }} {{ carteBancaireMasque(carte.attributes.num_carte) }}
        </p>
      </div>
    </div>
    <div class="u-flex u-flex-justify-center u-mt-md">
      <Button
        variant="primary"
        radius="full"
        size="md"
        @click="$emit('deleteCarte', carte.attributes.id_alias )"
      >
        Oui, je supprime
      </Button>
    </div>
    <FormError
      v-if="error"
      class="u-mt-sm u-text-center"
      :error="error"
    />
  </div>
</template>

<style lang="scss" scoped>
.c-payment-card-list-delete__content {
  max-width: 34.6rem;
  width: 100%;
  margin: 0 auto;

  @include mq(bp(md)) {
    display: inline-block;
    max-width: none;
    width: auto;
  }
}
</style>
